const routes = [
  // {
  //   path: "/ncme",
  //   name: authCodeMap.ncme,
  //   component: (): any => import("@/modules/ncmeManage/router.vue"),
  //   redirect: "/ncme/liveCenter",
  //   meta: {
  //     title: "ncme",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.ncme,
  //   },
  //   children: [
  //     {
  //       path: "liveCenter",
  //       name: authCodeMap.ncme_liveCenter,
  //       component: (): any => import("@/modules/ncmeManage/pages/liveCenter/liveManage/index.vue"),
  //       meta: {
  //         title: "直播管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_liveCenter,
  //       },
  //     },
  //     {
  //       path: "lecturerManage",
  //       name: authCodeMap.ncme_lecturerManage,
  //       component: (): any => import("@/modules/ncmeManage/pages/lecturerManage/index.vue"),
  //       meta: {
  //         title: "讲师管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_lecturerManage,
  //       },
  //     },
  //     {
  //       path: "liveCenter_edit",
  //       name: authCodeMap.ncme_liveCenter_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/liveCenter/liveManage/edit/index.vue"),
  //       meta: {
  //         title: "直播管理_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_liveCenter_edit,
  //       },
  //     },
  //     {
  //       path: "liveCenter_view",
  //       name: authCodeMap.ncme_liveCenter_view,
  //       component: (): any => import("@/modules/ncmeManage/pages/liveCenter/liveManage/view/index.vue"),
  //       meta: {
  //         title: "直播管理_查看",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_liveCenter_view,
  //       },
  //     },
  //     {
  //       path: "liveCenter_multiLiveData",
  //       name: authCodeMap.ncme_liveCenter_multiLiveData,
  //       component: (): any => import("@/modules/ncmeManage/pages/liveCenter/liveManage/multiLiveData/index.vue"),
  //       meta: {
  //         title: "直播管理_查看",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_liveCenter_multiLiveData,
  //       },
  //     },
  //     {
  //       path: "courseCenter_courseManage",
  //       name: authCodeMap.ncme_courseCenter_courseManage,
  //       component: (): any => import("@/modules/ncmeManage/pages/courseCenter/courseManage/index.vue"),
  //       meta: {
  //         title: "课程中心_课程管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_courseCenter_courseManage,
  //       },
  //     },
  //     {
  //       path: "courseCenter_courseManage_edit",
  //       name: authCodeMap.ncme_courseCenter_courseManage_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/courseCenter/courseManage/edit/index.vue"),
  //       meta: {
  //         title: "课程中心_课程管理_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_courseCenter_courseManage_edit,
  //       },
  //     },
  //     {
  //       path: "courseCenter_seriesCourseManage",
  //       name: authCodeMap.ncme_courseCenter_seriesCourseManage,
  //       component: (): any => import("@/modules/ncmeManage/pages/courseCenter/seriesCourseManage/index.vue"),
  //       meta: {
  //         title: "课程中心_系列课管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_courseCenter_courseManage,
  //       },
  //     },
  //     {
  //       path: "courseCenter_seriesCourseManage_edit",
  //       name: authCodeMap.ncme_courseCenter_seriesCourseManage_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/courseCenter/seriesCourseManage/edit/index.vue"),
  //       meta: {
  //         title: "课程中心_系列课管理_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_courseCenter_courseManage_edit,
  //       },
  //     },
  //     {
  //       path: "contentManage_articleManage",
  //       name: authCodeMap.ncme_contentManage_articleManage,
  //       component: (): any => import("@/modules/ncmeManage/pages/contentManage/articleManage/index.vue"),
  //       meta: {
  //         title: "学术文章_文章管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_contentManage_articleManage,
  //       },
  //     },
  //     {
  //       path: "contentManage_articleManage_edit",
  //       name: authCodeMap.ncme_contentManage_articleManage_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/contentManage/edit/index.vue"),
  //       meta: {
  //         title: "学术文章_文章管理_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_contentManage_articleManage_edit,
  //       },
  //     },
  //     {
  //       path: "ncme_academic_tasks",
  //       name: authCodeMap.ncme_academic_tasks,
  //       component: (): any => import("@/modules/ncmeManage/pages/tasks/index.vue"),
  //       meta: {
  //         title: "学术任务",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_academic_tasks,
  //       },
  //     },
  //     {
  //       path: "ncme_academic_tasks_edit",
  //       name: authCodeMap.ncme_academic_tasks_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/tasks/edit.vue"),
  //       meta: {
  //         title: "学术任务_编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_academic_tasks_edit,
  //       },
  //     },
  //     {
  //       path: "ncme_academic_tasks_detail",
  //       name: authCodeMap.ncme_academic_tasks_detail,
  //       component: (): any => import("@/modules/ncmeManage/pages/tasks/detail.vue"),
  //       meta: {
  //         title: "学术任务_详情",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_academic_tasks_detail,
  //       },
  //     },
  //     {
  //       path: "ncme_special_area",
  //       name: authCodeMap.ncme_special_area,
  //       component: (): any => import("@/modules/ncmeManage/pages/specialArea/index.vue"),
  //       meta: {
  //         title: "专区",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_special_area,
  //       },
  //     },
  //     {
  //       path: "ncme_special_area_edit",
  //       name: authCodeMap.ncme_special_area_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/specialArea/edit.vue"),
  //       meta: {
  //         title: "专区编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_special_area_edit,
  //       },
  //     },
  //     {
  //       path: "access_setting",
  //       name: authCodeMap.ncme_access_setting,
  //       component: (): any => import("@/modules/ncmeManage/pages/globalController/accessManage/index.vue"),
  //       meta: {
  //         title: "访问设置",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_access_setting,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_questionnaire,
  //       name: authCodeMap.ncme_questionnaire,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/index.vue"),
  //       meta: {
  //         title: "赋能_问卷",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_questionnaire,
  //       },
  //     },
  //     {
  //       path: "addQuestion",
  //       name: "ncme_addQuestion",
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/addQuestion.vue"),
  //       meta: {
  //         title: "新增题目",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: "ncme_questionBank_addBtn",
  //       },
  //     },
  //     {
  //       path: "catalogManage",
  //       name: "ncme_catalogManage",
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/QuestionCatalogManagePage.vue"),
  //       meta: {
  //         title: "分类管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: "ncme_catalogManage",
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_questionnaire_answerSheetPage,
  //       name: authCodeMap.ncme_questionnaire_answerSheetPage,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/answerSheetPage.vue"),
  //       meta: {
  //         title: "赋能_问卷_答卷",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_questionnaire_answerSheetPage,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_questionnaire_answerSheetDetail,
  //       name: authCodeMap.ncme_questionnaire_answerSheetDetail,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/answerSheetDetail.vue"),
  //       meta: {
  //         title: "赋能_问卷_答卷详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_questionnaire_answerSheetDetail,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_questionnaire_edit,
  //       name: authCodeMap.ncme_questionnaire_edit,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaireEdit/index.vue"),
  //       meta: {
  //         title: "赋能_问卷_设置",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.ncme_questionnaire_edit,
  //       },
  //     },
  //     {
  //       path: "activeCenterDetail",
  //       name: authCodeMap.ncme_active_center_detail,
  //       component: (): any => import("@/modules/ncmeManage/pages/activeCenter/activeDetail/index.vue"),
  //       meta: {
  //         title: "活动明细",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_active_center_detail,
  //       },
  //     },
  //     {
  //       path: "activeManage",
  //       name: authCodeMap.ncme_active_center_manage,
  //       component: (): any => import("@/modules/ncmeManage/pages/activeCenter/activeManage/index.vue"),
  //       meta: {
  //         title: "活动管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_active_center_manage,
  //       },
  //     },
  //     {
  //       path: "activeManageEdit",
  //       name: authCodeMap.ncme_active_center_manage_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/activeCenter/activeManage/edit.vue"),
  //       meta: {
  //         title: "新建活动",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_active_center_manage_edit,
  //       },
  //     },
  //     {
  //       path: "activeManageDetail",
  //       name: authCodeMap.ncme_active_center_manage_detail,
  //       component: (): any => import("@/modules/ncmeManage/pages/activeCenter/activeManage/detail.vue"),
  //       meta: {
  //         title: "活动详情",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_active_center_manage_detail,
  //       },
  //     },
  //     {
  //       path: "ncme_dataBoard_dataOverView",
  //       name: authCodeMap.ncme_dataBoard_dataOverView,
  //       component: (): any => import("@/modules/ncmeManage/pages/dataBoard/dataOverView.vue"),
  //       meta: {
  //         title: "数据概览",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_dataBoard_dataOverView,
  //       },
  //     },
  //     {
  //       path: "ncme_dataBoard_doctorOverView_show",
  //       name: authCodeMap.ncme_dataBoard_doctorOverView_show,
  //       component: (): any => import("@/modules/ncmeManage/pages/dataBoard/doctorOverView.vue"),
  //       meta: {
  //         title: "医生概览",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_dataBoard_doctorOverView_show,
  //       },
  //     },
  //     {
  //       path: "ncme_dataBoard_progress_details",
  //       name: authCodeMap.ncme_dataBoard_progress_details,
  //       component: (): any => import("@/modules/ncmeManage/pages/dataBoard/progressDetails.vue"),
  //       meta: {
  //         title: "进度明细",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_dataBoard_progress_details,
  //       },
  //     },
  //     {
  //       path: "ncme_dataBoard_contentOverView",
  //       name: authCodeMap.ncme_dataBoard_contentOverView,
  //       component: (): any => import("@/modules/ncmeManage/pages/dataBoard/contentOverView.vue"),
  //       meta: {
  //         title: "内容分析",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_dataBoard_contentOverView,
  //       },
  //     },
  //     {
  //       path: "ncme_dataBoard_campaignOverView",
  //       name: authCodeMap.ncme_dataBoard_campaignOverView,
  //       component: (): any => import("@/modules/ncmeManage/pages/dataBoard/campaignOverView.vue"),
  //       meta: {
  //         title: "活动分析",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_dataBoard_campaignOverView,
  //       },
  //     },
  //     {
  //       path: "renovation",
  //       name: authCodeMap.ncme_renovation_manage,
  //       component: (): any => import("@/modules/ncmeManage/pages/renovation/index.vue"),
  //       meta: {
  //         title: "装修管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_renovation_manage,
  //       },
  //     },
  //     {
  //       path: "communityInfo",
  //       name: authCodeMap.ncme_community_info,
  //       component: (): any => import("@/modules/ncmeManage/pages/globalController/communityInfo/index.vue"),
  //       meta: {
  //         title: "社区信息",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_community_info,
  //       },
  //     },
  //     {
  //       path: "communityInfoEdit",
  //       name: authCodeMap.ncme_community_info_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/globalController/communityInfo/components/edit.vue"),
  //       meta: {
  //         title: "社区信息编辑",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_community_info_edit,
  //       },
  //     },
  //     {
  //       path: "homePageEdit",
  //       name: authCodeMap.ncme_renovation_manage_home_page_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/renovation/homeEdit.vue"),
  //       meta: {
  //         title: "装修管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_renovation_manage_home_page_edit,
  //       },
  //     },
  //     {
  //       path: "articleCollection",
  //       name: authCodeMap.ncme_article_collection,
  //       component: (): any => import("@/modules/ncmeManage/pages/contentCollection/articleCollection/index.vue"),
  //       meta: {
  //         title: "文章采集",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_article_collection,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_channelManage_channelLinkList,
  //       name: authCodeMap.ncme_channelManage_channelLinkList,
  //       component: (): any => import("@/modules/ncmeManage/pages/channelManage/channelLinkList/channelLinkList.vue"),
  //       meta: {
  //         title: "链接管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_channelManage_channelLinkList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_channelManage_channelListManage,
  //       name: authCodeMap.ncme_channelManage_channelListManage,
  //       component: (): any => import("@/modules/ncmeManage/pages/channelManage/channelList/manage.vue"),
  //       meta: {
  //         title: "渠道管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_channelManage_channelListManage,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_channelManage_secondChannelList,
  //       name: authCodeMap.ncme_channelManage_secondChannelList,
  //       component: (): any => import("@/modules/ncmeManage/pages/channelManage/channelList/secondChannelList.vue"),
  //       meta: {
  //         title: "渠道管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_channelManage_secondChannelList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_channelManage_channelLinkList,
  //       name: authCodeMap.ncme_channelManage_channelLinkList,
  //       component: (): any => import("@/modules/ncmeManage/pages/channelManage/channelLinkList/channelLinkList.vue"),
  //       meta: {
  //         title: "链接管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_channelManage_channelLinkList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.ncme_channelManage_addChannelLink,
  //       name: authCodeMap.ncme_channelManage_addChannelLink,
  //       component: (): any => import("@/modules/ncmeManage/pages/channelManage/channelLinkList/addChannelLink.vue"),
  //       meta: {
  //         title: "链接",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_channelManage_addChannelLink,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messagePush",
  //       name: authCodeMap.ncme_message_center_push,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messagePush/list.vue"),
  //       meta: {
  //         title: "消息中心_消息推送",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_push,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messagePush_health",
  //       name: authCodeMap.ncme_message_center_push_health,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messagePush/list.vue"),
  //       meta: {
  //         title: "消息中心_消息推送",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_push_health,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messagePush_doctor",
  //       name: authCodeMap.ncme_message_center_push_doctor,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messagePush/list.vue"),
  //       meta: {
  //         title: "消息中心_消息推送",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_push_doctor,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messagePush/add",
  //       name: authCodeMap.ncme_message_center_push_add,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messagePush/add.vue"),
  //       meta: {
  //         title: "消息中心_消息推送_新建消息",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_push_add,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messagePush/edit",
  //       name: authCodeMap.ncme_message_center_push_edit,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messagePush/add.vue"),
  //       meta: {
  //         title: "消息中心_消息推送_编辑消息",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_push_edit,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messageRecord",
  //       name: authCodeMap.ncme_message_center_record,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messageRecord/list.vue"),
  //       meta: {
  //         title: "消息中心_消息记录",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_record,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messageRecord_health",
  //       name: authCodeMap.ncme_message_center_record_health,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messageRecord/list.vue"),
  //       meta: {
  //         title: "消息中心_消息记录",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_record_health,
  //       },
  //     },
  //     {
  //       path: "messageCenter/messageRecord_doctor",
  //       name: authCodeMap.ncme_message_center_record_doctor,
  //       component: (): any => import("@/modules/ncmeManage/pages/messageCenter/messageRecord/list.vue"),
  //       meta: {
  //         title: "消息中心_消息记录",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.ncme_message_center_record_doctor,
  //       },
  //     },
  //   ],
  // },
];
export default routes;